var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.28 33.56a1.5 1.5 0 01-1.06-.44L15.66 2.56A1.5 1.5 0 0117.78.44L48.34 31a1.5 1.5 0 01-1.06 2.56z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.72 64.13a1.5 1.5 0 01-1.06-2.56L46.22 31a1.5 1.5 0 112.12 2.12L17.78 63.69a1.5 1.5 0 01-1.06.44z"
  })));
}
export default SvgRightArrow;